var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIconNft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 2L14.875 2M6.75 2C6.75 2.69036 6.19036 3.25 5.5 3.25C4.80964 3.25 4.25 2.69036 4.25 2M6.75 2C6.75 1.30964 6.19036 0.75 5.5 0.75C4.80964 0.75 4.25 1.30964 4.25 2M1.125 2H4.25M6.75 12H14.875M6.75 12C6.75 12.6904 6.19036 13.25 5.5 13.25C4.80964 13.25 4.25 12.6904 4.25 12M6.75 12C6.75 11.3096 6.19036 10.75 5.5 10.75C4.80964 10.75 4.25 11.3096 4.25 12M1.125 12L4.25 12M11.75 7L14.875 7M11.75 7C11.75 7.69036 11.1904 8.25 10.5 8.25C9.80964 8.25 9.25 7.69036 9.25 7M11.75 7C11.75 6.30964 11.1904 5.75 10.5 5.75C9.80964 5.75 9.25 6.30964 9.25 7M1.125 7H9.25",
    stroke: "#2E293D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIconNft);
export default __webpack_public_path__ + "static/media/FilterIconNft.e573226d5bdd1b17729708c068becb98.svg";
export { ForwardRef as ReactComponent };